module.exports = __webpack_public_path__ + "img/call.8adb0a23.svg";